module.exports = __webpack_public_path__ + "static/media/icon-expand.7364b097.svg";